module.exports = __webpack_public_path__ + "fonts/Inter-ExtraBoldItalic.57ea76d.woff2";